import api from './api';

export const formService = {
  // Get all forms
  getAll: async (internalOnly = null) => {
    const params = internalOnly !== null ? { internalOnly } : {};
    const response = await api.get('/forms', { params });
    return response.data;
  },

  // Get form by ID
  getById: async (id) => {
    const response = await api.get(`/forms/${id}`);
    return response.data;
  },

  // Resolve a form link token to get form info
  resolveToken: async (token) => {
    const response = await api.get(`/formlinks/${token}`);
    return response.data;
  },

  getResumeGate: async (token) => {
    const response = await api.get(`/formlinks/${token}/resume`);
    return response.data;
  },

  startReusableLink: async (token, email) => {
    const response = await api.post(`/formlinks/${token}/start`, { email });
    return response.data;
  },

  verifyReusableCode: async (token, email, code) => {
    const response = await api.post(`/formlinks/${token}/verify-code`, { email, code });
    return response.data;
  },

  saveDraft: async (draftData) => {
    const response = await api.post('/formlinks/save-draft', draftData);
    return response.data;
  },

  /// Background draft write. Unlike saveDraft this does not queue a resume email and
  /// does not create a row in the submissions list, so it is safe to call repeatedly -
  /// on step changes, or from the beforeunload beacon.
  saveDraftSilent: async (draftData) => {
    const response = await api.post('/formlinks/save-draft-silent', draftData);
    return response.data;
  },

  // Internal "Save as Draft" for the staff open-form (no token yet):
  // creates a new link pre-filled with the current answers.
  createDraftLink: async (draftData) => {
    const response = await api.post('/formlinks/create-draft', draftData);
    return response.data;
  },

  // Get form template
  getTemplate: async (id) => {
    const response = await api.get(`/forms/${id}/template`, {
      responseType: 'blob',
    });
    return response.data;
  },

  // Advisory pre-save check: flags answers that look like they were typed into the
  // wrong field. Never blocks anything on its own — the caller decides.
  checkPlacement: async ({ formId, fieldValues, signatureDataUrl }) => {
    const response = await api.post('/forms/placement-check', {
      formId,
      fieldValues,
      signatureDataUrl: signatureDataUrl || null,
    });
    return response.data;
  },

  // Submit form
  submit: async (formData) => {
    const response = await api.post('/forms/submit', formData, {
      headers: {
        'Content-Type': 'application/json',
      },
      responseType: 'blob',
    });
    return response;
  },

  // Get field configuration (public endpoint for patient-facing form)
  getFieldConfig: async (formId) => {
    const response = await api.get(`/forms/${formId}/configuration`);
    return response.data;
  },

  // Submit patient registration (onboarding form)
  submitRegistration: async (registrationData) => {
    const response = await api.post('/patient-registrations', registrationData, {
      headers: {
        'Content-Type': 'application/json',
      },
    });
    return response.data;
  },

  // Public maintenance status (no auth required)
  getMaintenanceStatus: async () => {
    const response = await api.get('/maintenance/status');
    return response.data;
  },
};

export default formService;
